import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { ThreeDotsVertical, Terminal } from 'react-bootstrap-icons';
import { Overlay, Popover } from 'react-bootstrap';
import SendCommandDialog from './SendCommandDialog'; // Import the new SendCommandDialog component

const DeviceActionCell = ({ row, onDelete, onlyRemoteTerminal }) => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showSendCommandDialog, setShowSendCommandDialog] = useState(false);
    const target = useRef(null);

    // Close the dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (target.current && !target.current.contains(event.target)) {
                setShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const openRemoteTerminal = () => {
        // Open terminal directly in a pop-out window
        const popupUrl = `${window.location.origin}/remote-terminal?hubName=${encodeURIComponent(row.thingName)}&popout=1`;
        const terminalWindow = window.open('', '_blank', 'width=1000,height=600');

        // Fallback when browser blocks popups
        if (terminalWindow) {
            terminalWindow.location.href = popupUrl;
            terminalWindow.focus();
        } else {
            navigate('/remote-terminal', {
                state: { hubName: row.thingName }
            });
        }

        setShow(false);
    };

    if (onlyRemoteTerminal) {
        return (
            <span
                style={{ cursor: 'pointer' }}
                title="Open Terminal"
                onClick={openRemoteTerminal}
            >
                <Terminal size={18} />
            </span>
        );
    }

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <span ref={target} style={{ cursor: 'pointer' }} onClick={() => setShow(!show)}>
                <ThreeDotsVertical />
            </span>
            <Overlay target={target.current} show={show} placement="bottom">
                <Popover id="popover-basic">
                    <Popover.Body>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span
                                style={{ cursor: 'pointer', padding: '5px' }}
                                onClick={() => {
                                    setShowSendCommandDialog(true);
                                    setShow(false);
                                }}
                            >
                                Send Command
                            </span>
                            <span
                                style={{ cursor: 'pointer', padding: '5px' }}
                                onClick={openRemoteTerminal}
                            >
                                Start Terminal
                            </span>
                            <span
                                style={{ cursor: 'pointer', padding: '5px' }}
                                onClick={() => navigate(`/devices/health/${encodeURIComponent(row.thingName)}`)}
                            >
                                Health Check
                            </span>
                            <span style={{ cursor: 'pointer', padding: '5px', color: 'red' }} onClick={() => onDelete(row?.thingName)}>
                                Delete
                            </span>
                        </div>
                    </Popover.Body>
                </Popover>
            </Overlay>

            {/* SendCommandDialog with thingName */}
            <SendCommandDialog 
                show={showSendCommandDialog} 
                onHide={() => setShowSendCommandDialog(false)} 
                thingName={row.thingName} 
            />
        </div>
    );
};

DeviceActionCell.propTypes = {
    row: PropTypes.shape({
        thingName: PropTypes.string.isRequired,
    }).isRequired,
    onDelete: PropTypes.func,
    onlyRemoteTerminal: PropTypes.bool,
};

DeviceActionCell.defaultProps = {
    onDelete: () => {},
    onlyRemoteTerminal: false,
};

export default DeviceActionCell;
